import { Gender } from "@/gql/graphql";

type ReturnValue = {
  idealBodyWeightKgOne: number;
  idealBodyWeightKgTwo: number;
  idealBodyWeightLbsOne: number;
  idealBodyWeightLbsTwo: number;
};

export const LBS_MULTIPLIER = 2.205;

export const getIdealBodyWeight = (heightCm: number): ReturnValue => {
  /**
   * Healthy BMI range according to WHO is 18.5 - 25 for both female and male
   * To calculate ideal body weight
   * BMI index × ([the actual patient’s height in meters]^2)
   */

  const heigthInMeters = round(heightCm / 100, 1);
  const idealBodyWeightKgOne = round(18.5 * Math.pow(heigthInMeters, 2), 1);
  const idealBodyWeightKgTwo = round(25 * Math.pow(heigthInMeters, 2), 1);
  const idealBodyWeightLbsOne = round(idealBodyWeightKgOne * LBS_MULTIPLIER, 1);
  const idealBodyWeightLbsTwo = round(idealBodyWeightKgTwo * LBS_MULTIPLIER, 1);

  const result: ReturnValue = {
    idealBodyWeightKgOne,
    idealBodyWeightKgTwo,
    idealBodyWeightLbsOne,
    idealBodyWeightLbsTwo,
  };

  return result;
};

export const getDevineIdealBodyWeight = (
  height: number | undefined,
  gender: Gender | undefined
): number | null => {
  /**
   * Devine formula
     Metric:
    Men	  Wt (kg) = 50.0 + 2.3 for every inch over 5 feet
    Women	Wt (kg) = 45.5 + 2.3 for every inch over 5 feet
   */
  if (!height || !gender) return null;
  const DEFAULT_IDEAL_BODY_WEIGHT_FOR_MEN = 50.0;
  const DEFAULT_IDEAL_BODY_WEIGHT_FOR_WOMEN = 45.5;
  const MULTIPLIER_PER_INCH = 2.3;

  const heightInInches = height * 0.3937;
  const exceedingInches = heightInInches - 60;
  const idealBodyWeightForMen =
    DEFAULT_IDEAL_BODY_WEIGHT_FOR_MEN +
    MULTIPLIER_PER_INCH * Math.max(exceedingInches, 0);
  const idealBodyWeightForWomen =
    DEFAULT_IDEAL_BODY_WEIGHT_FOR_WOMEN +
    MULTIPLIER_PER_INCH * Math.max(exceedingInches, 0);

  const idealBodyWeight =
    gender === Gender.Male ? idealBodyWeightForMen : idealBodyWeightForWomen;

  return round(idealBodyWeight, 2);
};
const round = (value: number, decimal: number): number => {
  return parseFloat(value.toFixed(decimal));
};
